import { render } from "./StreamPlayer.vue?vue&type=template&id=37ba607e&scoped=true"
import script from "./StreamPlayer.vue?vue&type=script&lang=js"
export * from "./StreamPlayer.vue?vue&type=script&lang=js"

import "./StreamPlayer.vue?vue&type=style&index=0&id=37ba607e&scoped=true&lang=css"

import exportComponent from "D:\\perject\\suyuan\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ba607e"]])

export default __exports__